import AnswerType from "../types/AnswerType";
import Ticket from "../types/Ticket";
import { Product } from "../types/TicketResponse";
import WaiterOption from "../types/WaiterOption";

export const createAnswer: (ticket?: Ticket | null, waiter?: WaiterOption | null, products?: Product[]) => AnswerType = (
    ticket = null,
    waiter = null,
    products = []
) => ({
    type: "xetux-config",
    waiter,
    ticket,
    products,
});

export const createTicket: (
    ticketN?: number,
    table?: number,
    guests?: number,
    amount?: number
) => Ticket = (ticketN = 0, table = 0, guests = 0, amount = 0) => ({
    ticketN,
    table,
    guests,
    amount,
});
